module.exports = __webpack_public_path__ + "static/media/ExpertMFD_FAQs.c9d3a194.pdf";